import store from '../../store';

export default class AgentLoginEvent {
  constructor(body) {
    console.log('Informações recebidas de login : ', body);
    let attendance = {
      logged: true,
      agentId: body.agentId,
      agentName: body.agentName,
    };
    localStorage.Attendance = JSON.stringify(attendance);
    store.dispatch('updateAttendance', attendance);
  }
}
